import { useListDemoTenantsQuery } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { useNotificationContext } from '../components/Notification/NotificationContext';

export const useFetchDemoTenant = () => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const { showErrorNotification } = useNotificationContext();

  const { data: demoTenantsQueryData, loading: isFetchingDemoTenants } =
    useListDemoTenantsQuery({
      variables: {
        request: {
          tenantID,
        },
      },
      onError: () => {
        showErrorNotification({
          contentComponent: 'Failed to fetch demo tenants',
          props: {},
        });
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    });

  const demoTenants = demoTenantsQueryData?.listDemoTenants?.tenants;
  const demoTenant = demoTenants?.[0];

  return { tenant: demoTenant, isLoading: isFetchingDemoTenants };
};
